<template>
  <div>
    <div
      v-if="openCommentWysi && mentionsActivated === true"
      class="column is-narrow has-background-white is-border-right is-border-left is-flex is-padding">
      <div
        class="field">
        <input
          class="is-checkradio is-success"
          :id="'is_before_' + index"
          type="radio"
          :name="'radio_' + index"
          @change="$emit('updateRadio', true, index)"
          :checked="isBefore">
        <label :for="'is_before_' + index">Afficher au début de la rubrique</label>
        <input
          class="is-checkradio is-success"
          :id="'is_not_before_' + index"
          @change="$emit('updateRadio', false, index)"
          type="radio"
          :name="'radio_' + index"
          :checked="isBefore == false">
        <label :for="'is_not_before_' + index">Afficher a la fin de la rubrique</label>
      </div>
    </div>
    <div class="is-border-right is-border-left is-padding-xsmall is-padding-top-small is-padding-bottom-small">
      <div
        v-if="!openCommentWysi"
        class="vadDiscussion"
        style="cursor: pointer;">
        <div class="is-padding-bottom-xsmall">
          <span class="is-padding-right-xsmall has-text-grey ">
            <i class="fas fa-info-circle"></i>
          </span>
          <span
            class="is-size-6 has-text-grey has-text-weight-medium"
            v-if="isBefore">
            Cette mention sera intégrée avant les contenus dynamiques de cette section
          </span>
          <span
            class="is-size-6 has-text-grey has-text-weight-medium"
            v-else>
            Cette mention sera intégrée à la suite des contenus dynamiques de cette section
          </span>
        </div>
        <div
          class="vadDiscussion--bulle is-size-6 vadDiscussion--bulle--has-actions is-cut is-padding-left"
          style="min-height: 100px">
          <div
            class="content"
            v-if="comment"
            v-html="comment"></div>
          <div class="actionsOnRow actionsOnRow--vertical">
            <div class="">
              <button
                @click="openWysiwyg"
                class="is-min-height-full">
                <span class="icon is-small"><i class="fal fa-pencil"></i></span>
              </button>
            </div>
            <div class="">
              <button
                @click="$emit('deleteMention',index)"
                class="is-min-height-full">
                <span class="icon is-small"><i class="fal fa-trash-alt"></i></span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="is-border-top columns is-gapless">
        <div class="column">
          <wysiwyg-editor
            :light="true"
            :tooltip-top="true"
            :model="comment"
            background-color="has-background-white"
            @change="val => comment = val"
            class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
          </wysiwyg-editor>
        </div>
        <div class="actionsOnRow actionsOnRow--vertical">
          <div class="">
            <button
              type="button"
              :class="{'actionsOnRow-btn--hoverIsDanger': comment}"
              @click="openCommentWysi = false; comment = baseComment">
              <span class="icon is-small"><i class="fal fa-times"></i></span>
            </button>
          </div>
          <div>
            <button
              @click="patchComment(index)"
              type="button"
              class="button"
              :class="[(baseComment !== comment) ? 'is-success' : 'is-info']"
              :disabled="(baseComment === comment)">
              <span class="icon is-small">
                <i
                  class="fal fa-save"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'MentionSectionBloc',
  props: {
    isBefore: {
      type: Boolean
    },
    content: {
      type: String
    },
    index: {
      type: Number
    },
    mentionsActivated: {
      type: Boolean
    }
  },
  data () {
    return {
      comment: null,
      openCommentWysi: true,
      baseComment: null,
      openComment: true
    }
  },
  created () {
    this.comment = this.content
    this.baseComment = this.comment
  },
  methods: {
    openWysiwyg () {
      this.openCommentWysi = true
    },
    async patchComment (idx) {
      this.$emit('updateComment', this.comment, idx)
      this.openCommentWysi = !this.comment
      this.baseComment = this.comment
    }
  }
}
</script>
